import { render, staticRenderFns } from "./ExpiringLotes.vue?vue&type=template&id=2f8de994&scoped=true"
import script from "./ExpiringLotes.vue?vue&type=script&lang=js"
export * from "./ExpiringLotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8de994",
  null
  
)

export default component.exports